import "./Footer.css";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../pages/img/icon/colorlogo.png";
import React, { useState, useEffect } from "react";

const Footer = () => {
  /*const openEmail = () => {
    window.open('mailto:ihomhhotel@naver.com?subject=Subject&body=Body%20goes%20here')

  }*/

  const [isloggedIn, setLoggedIn] = useState(false);

  /*로그인 세션 체크*/
  useEffect(() => {
    fetch("https://thegmmedical.com:5002/check", {
      method: "get", // 통신방법
      headers: {
        "content-type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.message === "user존재") {
          setLoggedIn(true);
        }
      })
      .catch(() => {});
  }, []);

  /*로그아웃*/
  async function onLogout(e) {
    e.preventDefault();
    await fetch("https://thegmmedical.com:5002/api/logout", {
      method: "get", // 통신방법
      headers: {
        "content-type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
        window.location = "/";
      })
      .catch(() => {});
  }
  return (
    <footer className="footer">
      <section className="section section--sitemap">
        <div className="section__container">
          <div className="footer__logo">
            <img src={logo} alt="logo"></img>
          </div>
          <div className="footer__sitemap">
            {isloggedIn && (
              <div
                className="nav nav--footer"
                onClick={onLogout}
                style={{ cursor: "pointer" }}
              >
                <h3 className="nav__title">로그아웃</h3>
              </div>
            )}
            <div className="nav nav--footer">
              <h3 className="nav__title">Products</h3>
              <ul className="nav__list">
                <li className="nav__item">
                  <a className="nav__link " href="/software">
                    <span className="nav__text">RTMS</span>
                  </a>
                  <a className="nav__link " href="/device">
                    <span className="nav__text">Medical Device</span>
                  </a>
                </li>
              </ul>
            </div>

         

            <div className="nav nav--footer">
              <h3 className="nav__title">Company</h3>
              <ul className="nav__list">
                <li className="nav__item">
                  <a className="nav__link " href="/ceo">
                    <span className="nav__text">About</span>
                  </a>
                </li>

                <li className="nav__item">
                  <a className="nav__link " href="/location">
                    <span className="nav__text">Location</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="nav nav--footer">
              <h3 className="nav__title">Contact</h3>
              <ul className="nav__list">
                <li className="nav__item">
                  <a className="nav__link " href="/inquiry">
                    <span className="nav__text">Inquiry</span>
                  </a>
                </li>
       
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          (주)GM메디칼 | 경기도 고양시 덕양구 해포길 55-23, 뷰티플래닛 빌딩 대표자 :
          임명한 Copyright ⓒ 2024 GM MEDICAL. All rights reserved.
        </div>
      </section>
    </footer>
  );
};

export default Footer;
